import declare from "dojo/_base/declare";
import PostRequest from "csi/comm/PostRequest";
import { FIELD_OUTPUT_TYPE } from "./DGaaSSelectTemplate";
import Controller from "csi/action/Controller";
import Response from "csi/comm/JsonResponse";
import { addToFileUploadMap } from "./main";

const USE_LATEST_REVISION = "UseLatestRevisionOfTemplate";
const DGaaSRegenerateTemplateController = declare(Controller, {
	/**
	 * @override
	 * Set the parameters to the call method DocumentGenerator GenerateDocumentFromTemplate
	 */
	process() {
		const fd = this.getFormData();
		const cache = this.getCache();
		const docMaster = cache.getNode(this.m_urlNode);
		const currentRevision = cache.getNode(docMaster.CurrentRevision);
		const dGaaSTemplateRevision = currentRevision.DGaaSTemplateRevision;
		const docContainerURL = this.m_urlParent;

		const req = new PostRequest("DocumentGenerator", "RegenerateDocumentFromTemplate");
		req.addParameter("DGaaSTemplateRevision", dGaaSTemplateRevision);
		req.addParameter("ParentURL", docContainerURL);
		req.addParameter("DocumentType", fd.getFieldValue(FIELD_OUTPUT_TYPE));
		req.addParameter("UseLatestRevision", fd.getFieldValue(USE_LATEST_REVISION));
		req.addParameter("DocumentMasterURL", docMaster.$URL);
		this.waitForPublish(req.post());
	},

	/**
	 * @override
	 * Retrieves the newly created document and adds it to the browserStore map.
	 * This is necessary to display a ToolTip on the document's File attribute
	 * in case the document generation needs to be canceled.
	 */
	onPublishResponse(response: Response): void {
		const cache = this.getCache();
		addToFileUploadMap(response.getResultNode(), cache);
	},

	/**
	 * @Override
	 * Display Dialog Message to inform the request is accepted successfully
	 */
	postProcessSuccess() {
		this.widget.postActionRedrawNode(this);
		this.inherited(arguments);
	},
});
export = DGaaSRegenerateTemplateController;
